import { useSearchParams } from 'react-router-dom';
import { DEFAULT_PAGE, PAGE_PARAM_KEY } from 'consts/pagination';
import { Pagination } from 'types';
import { SEARCH_FILTER_KEY } from 'consts/filters/common/filtersKeys';
import { useEffect, useMemo, useState } from 'react';
import debounce from 'lodash/debounce';
import { DEBOUNCE_DELAY } from '../../consts/debounceDelay';

const DEFAULT_SEARCH_VALUE = '';

type SearchFilterProps = {
    currentPage?: Pagination['currentPage'];
};

export const useSearchFilter = ({ currentPage }: SearchFilterProps) => {
    const [searchParams, setSearchParams] = useSearchParams();

    const searchParam = searchParams.get(SEARCH_FILTER_KEY) || DEFAULT_SEARCH_VALUE;

    const [localValue, setLocalValue] = useState(searchParam);

    useEffect(() => {
        setLocalValue(searchParam);
    }, [searchParam]);

    const handleSearchInputDebounced = useMemo(
        () =>
            debounce((value: string) => {
                setSearchParams((prevSearchParams) => {
                    if (!value) prevSearchParams.delete(SEARCH_FILTER_KEY);
                    else prevSearchParams.set(SEARCH_FILTER_KEY, value);
                    if (currentPage && currentPage !== DEFAULT_PAGE)
                        prevSearchParams.set(PAGE_PARAM_KEY, DEFAULT_PAGE);

                    return prevSearchParams;
                });
            }, DEBOUNCE_DELAY),
        [setSearchParams, currentPage],
    );

    const handleSearchInput = (value: string) => {
        setLocalValue(value);
        handleSearchInputDebounced(value);
    };

    return {
        searchFilterDebounceValue: searchParam,
        searchFilterLocalValue: localValue,
        handleSearchInput,
    };
};
